"use client";

import SanityFooter from "@/contents/layout/SanityFooter"
import SanityHeader from "@/contents/layout/SanityHeader"
import {
  PageLayout as PageLayoutSanity,
  SiteConfig,
} from "@/contents/sanityTypes"
import { usePageMenuLayout } from "@/ui/hooks/usePageMenuPainter"
import { usePathname } from "next/navigation"
import { useEffect, useState } from "react"

export interface PageLayoutProps {
  settings: SiteConfig
  layout?: PageLayoutSanity
  children: React.ReactNode
  locale: string
}

const PageLayout = ({
  settings,
  layout,
  children,
  locale,
}: PageLayoutProps) => {
  const [menuOpen, setMenuOpen] = useState(false)
  const menuLayout = usePageMenuLayout()
  const pathname = usePathname()

  useEffect(() => {
    setMenuOpen(false)
  }, [pathname])

  return (
    <div className="min-h-[100vh] flex flex-col overflow-hidden">
      <header className="z-[11]">
        {settings.header && (
          <SanityHeader
            content={settings.header}
            layout={layout}
            menuOpen={menuOpen}
            menuColor={menuLayout.color}
            locale={locale}
            onMenuClick={() => setMenuOpen(!menuOpen)}
            onMenuClose={() => setMenuOpen(false)}
          />
        )}
      </header>
      <main className="flex-1">{children}</main>
      {settings.footer && <SanityFooter content={settings.footer as any} />}
    </div>
  )
}

export default PageLayout
